/**
 * Mapping configuration for the audit trail table columns.
 * Filter keys are plain (unprefixed) — they match `listAuditEventsInputSchema.filters`
 * in `src/app/useCases/audit/listAuditEvents.ts` directly.
 */
import { getArrayValue } from '@/lib/utils/table-state-utils';

export const auditTrailFilterMapping = {
  action: (value: any) => ({
    action: getArrayValue(value),
  }),
  operation: (value: any) => ({
    operation: getArrayValue(value),
  }),
  entityType: (value: any) => ({
    entityType: getArrayValue(value),
  }),
  actorId: (value: any) => ({
    actorId: getArrayValue(value),
  }),
  storeId: (value: any) => ({
    storeId: getArrayValue(value),
  }),
  createdAt: (value: any) => ({
    createdAt: value,
  }),
};

export const auditTrailQueryParamsMapping = {
  action: (value: URLSearchParams) => value.get('action')?.split(','),
  operation: (value: URLSearchParams) => value.get('operation')?.split(','),
  entityType: (value: URLSearchParams) => value.get('entityType')?.split(','),
  actorId: (value: URLSearchParams) => value.get('actorId')?.split(','),
  storeId: (value: URLSearchParams) => value.get('storeId')?.split(','),
  createdAt: (value: URLSearchParams) => {
    const res = value.get('createdAt');
    return res ? JSON.parse(res) : null;
  },
};

export const auditTrailSortMapping = {
  createdAt: 'createdAt' as const,
  action: 'action' as const,
};
